import { BaseService } from "./../../base";
export class ScheduleCitationService extends BaseService {
  static get entity() {
    return "schedule_citation";
  }
  static get name() {
    return "schedule_citation";
  }
  static async getByPatientIdFilter(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_patient_id_filter`, this.name, payload);
  }
  static async getByPatientId(id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_patient_id/${id}`, this.name);
  }
  static async getByReportCitation(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_report_citation`, this.name, payload);
  }
  static async getByPatientAndConsultation(patient_id, consultation_id) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}schedules_citations/find_by_patient_id_service_id/${patient_id}/${consultation_id}`,
      this.name
    );
  }
  static async getByPatientConsultationState(patient_id, consultation_id, state) {
    return this.submit(
      "get",
      `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_patient_id_service_id_state/${patient_id}/${consultation_id}/${state}`,
      this.name
    );
  }
  static async getByInterconsult(interconsult_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_interconsult_id/${interconsult_id}`, this.name);
  }
  /**
   * @param {Object} payload
   * @param {number | null} payload.professional_id when -> profesional_id de schedule_citation
   * @param {string | null} payload.state when -> state de schedule_citation
   * @param {string | null} [payload.date] when -> date exacta de schedule_detail.day_selected.date
   * @param {string | null} [payload.start_date] when -> fecha inicial de schedule_detail.day_selected.date
   * @param {string | null} [payload.end_date] when -> fecha final de schedule_detail.day_selected.date
   * @param {string | null} payload.name when -> name de schedule_detail.schedule.name
   * @param {boolean | null} payload.show_group when -> name de schedule_detail.schedule.name
   *
   * @param {number} page
   * @returns
   */
  static async getByProfessional(payload, page) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_professional?page=${page}`, this.name, payload);
  }
  /**
   * @param {Object} payload
   * @param {number | null} payload.professional_id when -> profesional_id de schedule_citation
   * @param {string | null} payload.state when -> state de schedule_citation
   * @param {string | null} payload.date when -> date de schedule_detail.day_selected.date
   * @param {string | null} payload.name when -> name de schedule_detail.schedule.name
   *
   * @param {number} page
   * @returns
   */
  static async getByProfessionalNp(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_professional_nopaginate`, this.name, payload);
  }

  /**
   * @param {Object} payload
   * @param {number | null} payload.professional_id when -> profesional_id de schedule_citation
   * @param {string | null} payload.state when -> state de schedule_citation
   * @param {string | null} payload.date when -> date de schedule_detail.day_selected.date
   * @param {string | null} payload.name when -> name de schedule_detail.schedule.name
   * @param {string | null} payload.schedule_id when -> id de schedule_detail.schedule.id
   * @returns
   */
  static async getByProfessionalNotPaginate(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_professional_no_paginate`, this.name, payload);
  }
  static async getByProfessionalNotPaginatePerformance(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_professional_no_paginate_performance`, this.name, payload);
  }
  /**
   *
   * @param {Object} payload
   * @param {number | null} payload.professional_id when -> profesional_id de schedule_citation
   * @param {string | null} payload.service_node_id when -> service_node asociado a consultant
   * @param {string | null} payload.start_date when -> date de schedule_detail.day_selected.date
   * @param {string | null} payload.end_date when -> date de schedule_detail.day_selected.date
   * @returns
   */
  static async getExportCitationAdministrative(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/export_citations_administrative`, null, payload, {
      responseType: "blob",
    });
  }

  static async getExportMaxillofacialCitations(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/export_maxillofacial_citations`, null, payload, {
      responseType: "blob",
    });
  }

  static async getExportCitationCne(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/export_citations_cne`, null, payload, {
      responseType: "blob",
    });
  }

  /**
   *
   * @param {Object} payload
   * @param {number | null} payload.service_node_id when -> service_node_id de la consulta asociada a la cita
   * @param {string | null} payload.start_date fecha del deleted_at
   * @param {string | null} payload.end_date fecha del deleted_at
   * @param {string | null} payload.node_id id del establecimiento
   * @returns
   */
  static async getReportDeletedCitation(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_deleted_citation`, null, payload, {
      responseType: "blob",
    });
  }

  static async getByRceDetailId(rce_detail_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_rce_detail_id/${rce_detail_id}`, this.name);
  }

  /**
   *
   * @param {*} interconsult_id
   * @returns entrega los schedules_citations que tengan asociada el interconsult_id con estado como nsp y tipo de consulta nueva
   */
  static async consecutive_nsp(interconsult_id, schedule_citation_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/consecutive_nsp/${interconsult_id}/${schedule_citation_id}`, this.name);
  }

  /**
   *
   * @param payload.schedule_id
   * @param payload.patient_id
   * @param payload.unity_id
   * @param payload.service_node_id
   * @param payload.node_id
   * @param payload.schedule_citation_state
   * @param payload.
   * @returns {Promise<unknown>}
   */
  static async getByFilterAll(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/filter_all`, this.name, payload);
  }

  /**
   *  Se realiza el proceso completo de la citación y sus respectivas validaciones
   *
   * @param payload.user_id -> el usuario que realiza la acción
   * @param payload.patient_id -> el id del paciente que se desea citar
   * @param payload.control_order (opcional) -> el objeto control_order, se ocupa para validación y para actualizar el control_order
   * @param payload.interconsult_data_filter (opcional) -> el objeto con los valores para realizar la búsqueda en interconsult/find_by_state_step_node_doesnthaveic_service_patient
   * @param payload.schedule_id -> el id de la agenda a la cual se desea citar el paciente
   * @param payload.interconsult_id (opcional) -> el id de la interconsulta en caso que la cita sea nueva y/o requiera ic
   * @param payload.step -> el step del interconsult_movement (se agregará en backend en caso de ser necesario)
   * @param payload.schedule_citation_id -> el id del schedule_citation creado con anterioridad, creo que esto ya no se ocupa pero lo dejé por si acaso
   * @param payload.schedule_detail_id -> el id del schedule_detail al cual se desea citar
   * @param payload.medical_admission_id -> el id de la admisión médica, en caso de tenerla
   * @param payload.consultation_type_id -> el id del consultation_type que finalmente se elija
   * @returns {Promise<unknown>}
   *
   * retorna un objeto con el siguiente formato
   * {
   *  code: int,
   *  message: string
   * }
   * Los códigos son:
   *    - 1 -> El paciente no tiene ic disponible cuando el tipo de consulta requiere sic
   *    - 2 -> La cita es control pero no tiene orden de control
   *    - 3 -> La cita es control pero la orden de control no tiene medical_admission_id
   *    - 4 -> El tipo de consulta es control migración, te muestra sic disponibles en caso de no tener admisión
   *    - 5 -> El paciente cuenta con una o más de una admisión en el centro
   *    - 6 -> El paciente cuenta con más de una cita en el mismo día
   *    - 7 -> El cupo seleccionado ya cuenta con una cita asociada
   *    - 8 -> Se cita con un tipo de consulta que requiere interconsulta y no se envia ic, por lo que se devuelven las ics disponibles para citar según filtros enviados
   *    - 9 -> Se cita como espontanea pero no se envia interconsulta, por lo que se envian las interconsultas espontaneas disponibles para citar
   *    - 10 -> Se cita como control pero no se envía una orden de control, por lo que se devuelven las ordenes de control activas
   *    - 11 -> En COSAM el paciente cuenta con un tarjetero activo independiente del servicio cuando se cita con tipo de consulta nueva
   *    - 200 -> La cita se realiza correctamente
   */
  static async storeCitation(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/store_citation`, "response", payload);
  }
  static async reportDentalFiles(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_dental_files`, null, payload, {
      responseType: "blob",
    });
  }
  static async reportRem07(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_rem07`, null, payload, {
      responseType: "blob",
    });
  }
  static async reportComgesSidra(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_comges_sidra`, null, payload, {
      responseType: "blob",
    });
  }
  static async reportRem07Natales(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_rem07_natales`, null, payload, {
      responseType: "blob",
    });
  }
  static async report_program(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_program`, null, payload, {
      responseType: "blob",
    });
  }
  static async reportExcel(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_by_report_citation_excel`, null, payload, {
      responseType: "blob",
    });
  }
  static async transerCitations(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/transfer_citations`, "response", payload);
  }
  static async reverse_state_citation(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/reverse_state_citation`, "response", payload);
  }
  static async remove_schedule_citation(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/remove_schedule_citation`, "response", payload);
  }
  static async reverse_state_citation(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/reverse_state_citation`, "response", payload);
  }
  static async remove_schedule_citation(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/remove_schedule_citation`, "response", payload);
  }
  static async get_pending_schedule_citations(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/get_pending_schedule_citations`, this.name, payload);
  }
  static async send_keiron_event(schedule_citation_id) {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/send_keiron_event/${schedule_citation_id}`, this.name);
  }
  static async change_state_nsp(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/change_state_nsp`, "response", payload);
  }
  static async update_arrival_time(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/update_arrival_time`, "response", payload);
  }
  static async report_citation_discharge(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_medical_discharge`, null, payload, {
      responseType: "blob",
    });
  }
  static async report_group_activity(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/report_group_activity`, null, payload, {
      responseType: "blob",
    });
  }
  static async findCitationMaActivityByPatient(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/find_citation_ma_activity_by_patient`, null, payload);
  }
  static async updateArchiveRequestAllCitations(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/update_archive_request_all_citations`, null, payload);
  }
  static async countScheduleCitationPending(payload) {
    return this.submit("post", `${this.getApiUrlEntity(this.profile)}${this.entity}/count_schedule_citation_pendings`, null, payload, {
      showFullResponse: true,
    });
  }
}
